import React from 'react';
import s from './spinner.module.css';
export function Spinner(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return React.createElement("div", { className: "".concat(s.spinner, " ").concat(className) });
}
//# sourceMappingURL=Spinner.js.map